// extracted by mini-css-extract-plugin
export default {"video-modal":"styles-module__video-modal___mmu5H"};